module.exports = __webpack_public_path__ + "static/media/it5.1ca53e9c.jpeg";